import { QuoteReviewListItemContent } from './components/listItemContent/QuoteReviewListItemContent'
import { QuoteReviewContent } from './components/reviewContent/QuoteReviewContent'

export const quoteReviewManualTask = {
  reviewContent: QuoteReviewContent,
  listItemContent: QuoteReviewListItemContent
}

export * as QuoteReviewTask from './types'
